/* template */
<template minapp="mpx" xlang="wxml"><mpx-view @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd"><div :style='[("transform:"+(transformY)+";")] | transRpxStyle' class="pulldown" v-if="(showPullDown)"><mpx-image :src="(loadingImg)" class="pulldown-loading"/><div class="pulldown-text">松开立即刷新</div></div><div :style='[("transform:"+(transformY)+";")] | transRpxStyle'><slot/></div></mpx-view></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m037d3522"}'>
  @import '../common/style/bem'

  .pulldown
    display flex
    justify-content center
    align-items center
    width 100%
    height 40px
  .pulldown-text
    font-size 14px
    color #FFFFFF
    padding-right 28px
  .pulldown-loading
    width 20px
    height 20px
    margin-right 15px
    animation spin 2s linear infinite
  @keyframes spin
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m037d3522"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex037d3522%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex037d3522%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m037d3522"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index037d3522/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
